import React, {useEffect} from 'react';
import axios from "axios";
import {useIntl} from 'react-intl';
import {apiConfig} from "./api-config";
import {useUserInfo} from "./hooks/useUserInfo";
import {useToast} from "./hooks/useToast";
import {usePreloader} from "./hooks/usePreloader";

interface Props {
    callback: () => void;
    children: React.ReactNode
}

export const AxiosInterceptor: React.FC<Props> = props => {
    const {showToast} = useToast();
    const {updateUserInfo, userInfo} = useUserInfo();
    const {formatMessage: f} = useIntl();
    const {setLoading} = usePreloader();

    //!IMPORTANT This function should stay in the useEffect so onComponentDidUnmount the interceptor is being ejected and the replaced with new one!
    useEffect(() => {
        const authInterceptor = axios.interceptors.request.use((config) => {
            const isSWRRequest = config.data && config.data.isSWR;
            if (!isSWRRequest)
                setLoading(true);
            config.baseURL = apiConfig.API_URL;
            config.withCredentials = true;
            // setLoading(true);
            return config
        });

        // axios.get('/kc/me',).then(res => {
        //     setData(res.data.username, res.data.userRole, res.data.darkMode);
        //     props.callback();
        // });
        props.callback();

        return () => {
            axios.interceptors.request.eject(authInterceptor);
        }

    }, [userInfo]);

    useEffect(() => {
        const responseInterceptor = axios.interceptors.response.use((response) => {
            const isSWRRequest = response.config.data && response.config.data.isSWR;
            if (!isSWRRequest)
                setLoading(false);

            return response;
        }, (err) => {
            setLoading(false);
            if (err.code && err.code === "ERR_NETWORK") {
                showToast("error", f({id: 'error'}), err.message);
                return Promise.reject(err);
            }

            if(err.response.status === 401 && err.config.url.includes('/checkIfAuthenticated') ){
                updateUserInfo({authenticated: false, role: undefined, userId: undefined, shouldChangePassword: undefined})
                return Promise.reject(err);
            }

            if (err.response.status === 401 && !err.config.url.includes('/auth')) {
                // updateUserInfo({authenticated: false, role: undefined, userId: undefined, shouldChangePassword: undefined})
                //Do not log out the user - instead show access forbidden message
                showToast('warn', f({id: "operationUnsuccessful"}), f({id: 'accessDenied'}), false);
                return Promise.reject(err);
            }


            const priority = err.response.status >= 400 && err.response.status < 500 ? "warn" : "error";
            let message = (err.response.status >= 400 && err.response.status < 500) ? err.response.data.message : "internalServerError";
            if (err.response.status === 401) {
                message = 'wrongUsernameOrPassword'
            } else if (err.response.status === 400 && err.response.data && err.response.data.errors && Object.values(err.response.data.errors).length > 0 ) {
                message = <ul>
                    {
                        Object.values(err.response.data.errors).map((el: any, index: number) => <li key={index}>{el}</li>)
                    }
                </ul>
                showToast(priority, f({id: "operationUnsuccessful"}), message, true);
                return Promise.reject(err);
            }
            const sticky = err.response.data.sticky;
            if (message !== undefined)
                showToast(priority, f({id: "operationUnsuccessful"}), f({id: message}), sticky);
            return Promise.reject(err);
        });

        return () => {
            axios.interceptors.response.eject(responseInterceptor);
        }
    }, [userInfo]);

    return <>
        {props.children}
    </>
};
